<!--
    描述：顶部菜单
    时间：2020-04-15
    Created by ws
-->
<template>
	<div class="w-top-menu">
		<el-scrollbar wrap-class="scrollbar-wrapper">
			<el-menu mode="horizontal"
					 :default-active="activeMenu"
					 text-color="#606266"
					 active-text-color="#409EFF"
					 @select="handleClick"
					 :collapse="isCollapse"
					 class="w-menu">
				<template v-for="(item, index) in menuList">
					<el-submenu v-if="item.children && filterChildren(item.children).length > 0"
								:index="item.name"
								class="w-menu w-menu-child">
						<template slot="title">
							<svg-icon :icon-class="item.icon ? item.icon : ''" />
							<span class="ml10">{{ item.meta.title }}</span>
						</template>
						<el-menu-item v-for="(m, n) in filterChildren(item.children)"
									  :key="'menu.children' + n"
									  :index="m.name"
									  class="w-child-item">
							<svg-icon :icon-class="m.icon ? m.icon : ''" />
							<span class="ml10">{{ m.meta.title }}</span>
						</el-menu-item>
					</el-submenu>

					<el-menu-item :index="item.name"
								  v-else
								  class="w-menu-item">
						<svg-icon :icon-class="item.icon ? item.icon : ''" />
						<span class="ml10"
							  slot="title">{{ item.meta.title }}</span>
					</el-menu-item>
				</template>

			</el-menu>
		</el-scrollbar>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	data() {
		return {}
	},
	methods: {
		// 菜单点击事件
		handleClick(index, indexPath) {
			let _index = this.routeList.findIndex(x => x.name === index)
			if (_index > -1) {
				this.$router.push({
					path: this.routeList[_index].path
				})
			}
		},

		// children 过滤
		filterChildren(list) {
			let backArr = list.filter(x => !x.isHidden)
			return backArr
		}
	},
	computed: {
		...mapState('app', {
			isCollapse: state => state.isCollapse
		}),
		...mapState('menu', {
			activeRoutes: state => state.activeRoutes,
			routeList: state => state.routeList
		}),
		// 当前菜单
		activeMenu() {
			const route = this.$route
			let { name } = route
			
			if (route.matched && route.matched.length === 3 && route.matched[1].name === 'Project-management') {
				name = 'Project-management'
			}

			if (route.matched && route.matched.length === 3 && route.matched[1].name === 'Cost-analysis') {
				name = 'Cost-analysis'
			}

			return name
		},
		// 菜单列表
		menuList() {
			let arr = this.activeRoutes.find(x => x.name === 'Main')

			return arr.children.filter(x => !x.isHidden)
		}
	}
}
</script>

<style lang="less">
.w-top-menu {
	// @bgColor: #86eaea;
	@bgColor: transparent;
	// @hoverColor: #409eff;
	// @hoverTextColor: #2a3146;
	@hoverColor: #0073ab;
	@hoverTextColor: #fff;
	// @activeColor: #409eff;

	height: 100%;
	flex: 1;
	padding: 0 30px;
	overflow: hidden;
	background-color: @bgColor;

	.el-scrollbar {
		width: 100%;

		.scrollbar-wrapper {
			overflow-y: hidden;
        }
        
        .el-scrollbar__view {
            width: max-content;
        }
	}

	.el-menu {
		border: none;
		height: 100%;
		width: 100% !important;
		background-color: @bgColor;
	}

	.el-submenu__title {
		&:hover {
			color: @hoverTextColor !important;
			background-color: @hoverColor !important;
		}
	}

	.el-submenu {
		@sub-bg-color: #1f2d3d;

		.el-menu {
			background-color: @sub-bg-color;
		}

		.el-menu-item {
			background-color: @sub-bg-color;
		}

		.el-menu-item:hover {
			background-color: #001528;
		}
	}

	.el-menu--popup-bottom-start {
		margin-top: 0 !important;
	}

	.w-menu-item {
		height: 60px;
		line-height: 58px;
		margin: 0 5px;

		&:hover,
		&:active {
			background-color: @hoverColor !important;
			color: @hoverTextColor !important;
			// background-color: @hoverColor;
		}
	}
	// .w-menu-item.is-active {
	// 	color: @activeColor;
	// }
}
.el-menu--popup-bottom-start {
	margin-top: 0;
}
.w-child-item {
    // background-color: #2a3146 !important;
    
    &:hover {
        background-color: #0073ab !important;
        color: #fff !important;
    }
}
</style>
